import VueRouter from 'vue-router'
import { isLogin } from "@/utils/userInfo"

const router = new VueRouter({
    mode: 'hash',
    routes: [
        {
            path: '/home',
            name: 'home',
            component: () => import('@/views/reception/home/index.vue'),
            meta: { title: '首页' },
            children: [
                { path: '/guide', name: 'homeGuide', component: () => import('@/views/reception/home/guide/index.vue'), meta: { title: '工作台' } },
                { path: '/personal-user', name: 'personal-user', component: () => import('@/views/system/personal/index.vue'), meta: { title: '个人中心' } },

                { path: '/supplierInfo', name: 'supplierInfo', component: () => import('@/views/business/supplierInfo/index.vue'), meta: { title: '供应商管理' } },
                { path: '/product', name: 'product', component: () => import('@/views/business/product/index.vue'), meta: { title: '产品管理' } },
                { path: '/productInfo', name: 'supplierInfo', component: () => import('@/views/business/productInfo/index.vue'), meta: { title: '产品信息管理' } },

                { path: '/accountInfo', name: 'accountInfo', component: () => import('@/views/business/accountInfo/index.vue'), meta: { title: '开户信息' } },
                { path: '/address', name: 'address', component: () => import('@/views/business/address/index.vue'), meta: { title: '收货地址' } },
                { path: '/shipInfo', name: 'shipInfo', component: () => import('@/views/business/shipInfo/index.vue'), meta: { title: '船舶信息' } },
                { path: '/contactManager', name: 'contactManager', component: () => import('@/views/business/contactManager/index.vue'), meta: { title: '联系人管理' } },
                { path: '/details', name: 'details', component: () => import('@/views/business/details/index.vue'), meta: { title: '储罐费' } },
                { path: '/qualityFile', name: 'qualityFile', component: () => import('@/views/business/qualityFile/index.vue'), meta: { title: '质量标准管理' } },

                { path: '/shedManager', name: 'shedManager', component: () => import('@/views/business/shedManager/index.vue'), meta: { title: '库房管理' } },

                { path: '/storeManager', name: 'storeManager', component: () => import('@/views/business/storeManager/index.vue'), meta: { title: '入库管理' } },
                { path: '/outboundManager', name: 'outboundManager', component: () => import('@/views/business/outboundManager/index.vue'), meta: { title: '出库管理' } },
                { path: '/outboundExamin', name: 'outboundExamin', component: () => import('@/views/business/outboundExamin/index.vue'), meta: { title: '出库管理' } },

                { path: '/company', name: 'company', component: () => import('@/views/business/company/index.vue'), meta: { title: '企业管理' } },
                { path: '/userShow', name: 'userShow', component: () => import('@/views/business/userShow/index.vue'), meta: { title: '注册用户管理' } },

                { path: '/feedBack', name: 'feedBack', component: () => import('@/views/business/feedBack/index.vue'), meta: { title: '反馈管理' } },
                { path: '/supplierExamin', name: 'supplierExamin', component: () => import('@/views/business/supplierExamin/index.vue'), meta: { title: '供应商审核' } },
                { path: '/pointsShop', name: 'userShow', component: () => import('@/views/business/pointsShop/index.vue'), meta: { title: '积分商城' } },
                { path: '/pointsOrder', name: 'pointsOrder', component: () => import('@/views/business/pointsOrder/index.vue'), meta: { title: '积分订单' } },

                { path: '/longAgreement', name: 'longAgreement', component: () => import('@/views/business/longAgreement/index.vue'), meta: { title: '长协申请管理' } },

                { path: '/storageInfo', name: 'storageInfo', component: () => import('@/views/business/storageInfo/index.vue'), meta: { title: '仓储公司管理' } },
                { path: '/storageExamin', name: 'storageExamin', component: () => import('@/views/business/storageExamin/index.vue'), meta: { title: '仓储公司审核' } },
                { path: '/publicTank', name: 'publicTank', component: () => import('@/views/business/publicTank/index.vue'), meta: { title: '公共储罐' } },
                { path: '/unopen', name: 'UnopenPage', component: () => import('@/views/business/unopen/index.vue'), meta: { title: 'APP功能详情' } },

                { path: '/todayStock', name: 'todayStock', component: () => import('@/views/business/todayStock/index.vue'), meta: { title: '今日库存' } },
                { path: '/todayPlanIn', name: 'todayPlanIn', component: () => import('@/views/business/todayPlanIn/index.vue'), meta: { title: '今日进库计划' } },
                { path: '/todayPlanOut', name: 'todayPlanOut', component: () => import('@/views/business/todayPlanOut/index.vue'), meta: { title: '今日出货计划' } },

                { path: '/inventory', name: 'inventory', component: () => import('@/views/business/inventory/index.vue'), meta: { title: '储罐库存' } },

                { path: '/inquirySheet', name: 'inquirySheet', component: () => import('@/views/business/inquirySheet/index.vue'), meta: { title: '询价管理' } },
                { path: '/orderForm', name: 'orderForm', component: () => import('@/views/business/orderForm/index.vue'), meta: { title: '订单管理' } },
                { path: '/referencePrice', name: 'referencePrice', component: () => import('@/views/business/referencePrice/index.vue'), meta: { title: '区域参考价' } },
                { path: '/sales', name: 'salesIndex', component: () => import('@/views/business/sales/index.vue'), meta: { title: '统计报表' } },

                { path: '/noticeInfo', name: 'noticeInfo', component: () => import('@/views/business/noticeInfo/index.vue'), meta: { title: '公示公告' } },
                { path: '/latestVersion', name: 'latestVersion', component: () => import('@/views/business/latestVersion/index.vue'), meta: { title: 'APP更新控制' } },
                { path: '/msgPush', name: 'msgPush', component: () => import('@/views/business/msgPush/index.vue'), meta: { title: 'APP消息通知' } },
                { path: '/supplyPort', name: 'supplyPortIndex', component: () => import('@/views/business/supplyPort/index.vue'), meta: { title: '供油港口' } },

                { path: '/tankLink', name: 'tankLink', component: () => import('@/views/business/tankLink/index.vue'), meta: { title: '储罐申请' } },
                { path: '/tankLinkExamin', name: 'tankLinkExamin', component: () => import('@/views/business/tankLinkExamin/index.vue'), meta: { title: '储罐申请审核' } },

                { path: '/tankIn', name: 'tankIn', component: () => import('@/views/business/tankIn/index.vue'), meta: { title: '储罐入库申请' } },
                { path: '/tankInExamin', name: 'tankInExamin', component: () => import('@/views/business/tankInExamin/index.vue'), meta: { title: '储罐入库审核' } },

                { path: '/tankOut', name: 'tankOut', component: () => import('@/views/business/tankOut/index.vue'), meta: { title: '储罐出库申请' } },
                { path: '/tankOutExamin', name: 'tankOutExamin', component: () => import('@/views/business/tankOutExamin/index.vue'), meta: { title: '储罐出库审核' } },


                { path: '/dept', name: 'dept', component: () => import('@/views/system/dept/index.vue'), meta: { title: '部门管理' } },
                { path: '/role', name: 'role', component: () => import('@/views/system/role/index.vue'), meta: { title: '角色管理' } },
                { path: '/menu', name: 'menu', component: () => import('@/views/system/menu/index.vue'), meta: { title: '菜单管理' } },
                { path: '/user', name: 'user', component: () => import('@/views/system/user/index.vue'), meta: { title: '用户管理' } },
                { path: '/dict', name: 'dict', component: () => import('@/views/system/dict/index.vue'), meta: { title: '字典管理' } },

            ]
        },
        {
            path: '/login',
            name: 'login',
            alias: ['/'],
            component: () => import('@/views/reception/login/index.vue'),
            meta: { title: '睿畅油链管理平台' }
        }
    ]
})

//全局前置路由守卫
router.beforeEach((to, from, next) => {
    /* console.log(' 是否登录 ： ', isLogin())
    if (to.meta.isAuth && !isLogin()) {
        router.push({name:'login'})
        return;
    }*/
    document.title = to.meta.title || '平台'
    next()
})


export default router
